var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"clip-path":"url(#clip0_429_10986)"}},[_c('path',{attrs:{"d":"M6 9H18","stroke":"#292929","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6 15H18","stroke":"#292929","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }